import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AnnouncementBar from "@/components/AnnouncementBar";
import TelegramTopBar from "@/components/TelegramTopBar";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-ink">
      <AnnouncementBar />
      <TelegramTopBar />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
